var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-sensorQR"},[_c('img',{staticClass:"p-sensorQR__check",attrs:{"src":"/img/shop/img_qrcodeDecolation_check.png"}}),_c('div',{staticClass:"p-sensorQR__img"},[_c('canvas',{ref:"canvas",staticClass:"p-sensorQR__canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }